"use client";
import Script from "next/script";
import { initializeLogger } from ".";

export const FeLoggerClient = ({
  subscriptionKey,
  src,
}: {
  subscriptionKey: string;
  src: string;
}) => (
  <Script
    onReady={() => {
      initializeLogger({
        subscriptionKey,
      })();
    }}
    src={src}
  />
);
